import Albums from "./Albums/Albums.js";
import Labels from "./Labels/Labels.js";
import Artists from "./Artists/Artists.js";
import Playlists from "./Playlists/Playlists.js";
import Tracks from "./Tracks/Tracks.js";

import Filters from "./Filters/Filters.js";
import PageCommon from "./PageCommon.js";

import Globals from "../Globals.js";

export default class DataManager extends PageCommon {
    constructor() {
        super();
        this.data = {};
        this.dataStructure = {
            albums: [],
            labels: [],
            artists: [],
            artists_formats: [],
            playlists: [],
            tracks: [],
            filters: [],
            countries: [],
        };
        this.keywords = [];
        this.searchResults = [];
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("DataManager - constructor");
        this.maxRetry = 5;
        this.retryCounter = 0;
        this.timeoutGetAll = 2000;
    }

    init() {
        super.init();
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%DataManager - init", "color: orange");
        const urlParams = new URLSearchParams(window.location.search);
        this.getData(urlParams.get("debug"));
        Globals.dataManager = this;
    }

    getData(debug) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - Fetching Data", "color: orange");
        let url = `/apisounzone/getall/`;
        //   if (debug) {
        //    url = `/apisounzone/getall/?rand=${Date.now()}`;
        // url = `/apisounzone/getall/`;
        // } else {
        //   url = "https://sounzone.com/szwsbeta/?mode=DATA";
        //}
        fetch(url)
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - Fetch Data OK", "color: orange");
                this.retryCounter = 0;
                this.data = result.data;
                this.parseData();
            })
            .catch((error) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - ERROR Fetching Data", "color: orange", { message: error });
                if (this.retryCounter < this.maxRetry) {
                    this.retryCounter++;
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - Retry request", "color: orange", this.retryCounter);
                    this.getData();
                } else {
                    jQuery(".js-critical-error").show();
                }
            });
    }

    getDataPromise() {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - Promise Fetching Data", "color: orange");
        // this.promiseTimeout(this.timeoutGetAll, fetch("https://sounzone.com/szwsbeta/?mode=DATA"))
        // this.promiseTimeout(this.timeoutGetAll, fetch(`/apisounzone/getall/?rand=${Date.now()}`))
        this.promiseTimeout(this.timeoutGetAll, fetch(`/apisounzone/getall/`))
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - Promise Fetch Data OK", "color: orange");
                this.retryCounter = 0;
                this.data = result.data;
                this.parseData();
            })
            .catch((error) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - ERROR Promise Fetching Data", "color: orange", { message: error });
                if (this.retryCounter < this.maxRetry) {
                    this.retryCounter++;
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - Promise Retry request", "color: orange", this.retryCounter);
                    this.getDataPromise();
                }
            });
    }

    parseData() {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - Parsing Data", "color: orange");
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - Data saved", "color: orange", this.data);
        let firstpageTracks = [];
        let firstpageArtists = [];
        let firstpageProducers = [];
        let firstpageLabels = [];
        let countries = [];
        Object.keys(this.data).map((item, index) => {
            switch (item) {
                case "albums":
                    this.dataStructure[item] = new Albums(this.data[item]);
                    break;
                case "labels":
                    this.dataStructure[item] = new Labels(this.data[item]);
                    break;
                case "artists":
                    this.dataStructure[item] = new Artists(this.data[item], this.data["artists_formats"]);
                    break;
                case "playlists":
                    this.dataStructure[item] = new Playlists(this.data[item]);
                    break;
                case "tracks":
                    this.dataStructure[item] = new Tracks(this.data[item]);
                    break;
                case "firstpage_filters":
                    this.dataStructure["filters"] = new Filters(this.data[item]);
                    break;
                case "firstpage_artists":
                    firstpageArtists = this.data[item];
                    break;
                case "firstpage_producers":
                    firstpageProducers = this.data[item];
                    break;
                case "firstpage_tracks":
                    firstpageTracks = this.data[item];
                    break;
                case "firstpage_labels":
                    firstpageLabels = this.data[item];
                    break;
                case "countries":
                    countries = this.data[item];
                    break;
                default:
                    break;
            }
        });
        this.dataStructure.countries = countries;
        if (this.dataStructure.artists) {
            this.dataStructure.artists.firstpage = {
                artists: firstpageArtists,
                producers: firstpageProducers,
            };
        }
        if (this.dataStructure.tracks) {
            this.dataStructure.tracks.firstpage = firstpageTracks;
            this.dataStructure.tracks.artists = this.dataStructure.artists;
        }
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cDataManager - Parsing OK", "color: orange");
        this.emitEvent("data_ready");
    }

    renderPlacementsData(pm) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("DataManager - Fetching Placements Data");
        fetch(Globals.WS_URL+"?mode=PAGE.PLACEMENTS")
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("DataManager - Fetch Placements Data OK");

                var item = result.page_placements;
                var accordion = document.querySelector("#placementCont");
                accordion.textContent = "";
                const modelId = "#model-placement-item";

                if (pm == 1) {
                    if (item.length >= 4) {
                        for (var k = 0; k < 4; k++) item.push(item[k]);
                    }
                }

                item.map((item, index) => {
                    const plaItem = document.querySelector(`${modelId} .placement-item`).cloneNode(true);
                    const plaCont = plaItem.querySelector(".placementItemCont");
                    plaCont.style.backgroundImage = "url(" + item.img + ")";
                    const plaOver = plaItem.querySelector(".placementItemOver");
                    plaOver.addEventListener('click', function (event) {
                        window.open(item.link);
                    }, false);
                    const titleItem = plaItem.querySelector(".plaTit");
                    titleItem.innerHTML = item.title;
                    const textItem = plaItem.querySelector(".plaText");
                    textItem.innerHTML = item.content;
                    accordion.appendChild(plaItem);
                });

                const maxtpr = 3; // 4 - 3
                const tw = 341;   // 341 x 3 -- 256 x 4

                if (pm == 1 && item.length >= maxtpr) {
                    const marT = (item.length - maxtpr) * 4;
                    const marW = (item.length - maxtpr) * tw;
                    const marP = (100 / item.length) * (item.length - maxtpr);
                    document.styleSheets[0].insertRule("@keyframes clientsAnim { 0% { transform: translateX(0); } 100% { transform: translateX(-" + marW + "px); }}", document.styleSheets[0].cssRules.length);
                    document.styleSheets[0].insertRule("#placementCont { animation: clientsAnim " + marT + "s linear infinite; }", document.styleSheets[0].cssRules.length);
                }

            })
            .catch((error) => {
                Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                jQuery(".js-critical-error").show();
            });
    }

    renderFaqData() {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("DataManager - Fetching Faq Data");
        setTimeout(() => {
            jQuery("#faqAccordion .js-preloader").show();
        }, 200);
        fetch(Globals.WS_URL +"?mode=PAGE.FAQ")
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("DataManager - Fetch Faq Data OK");

                //  About subscriptions & specs

                var faq = result.page_faq_ss;
                var accordion = document.querySelector("#faqAccordionSS");
                accordion.textContent = "";
                const modelId = "#model-faq-item";

                faq.map((item, index) => {
                    const faqItem = document.querySelector(`${modelId} .faq-item`).cloneNode(true);
                    const titleItem = faqItem.querySelector(".faqTit");
                    const title = titleItem.querySelector("span");
                    titleItem.dataset.target = "#f_ss_" + index;
                    title.textContent = item.title;
                    const textItem = faqItem.querySelector(".faqText");
                    const text = textItem.querySelector("span");
                    textItem.setAttribute("data-parent", "#faqAccordionSS");
                    textItem.id = "f_ss_" + index;
                    text.innerHTML = item.content;
                    accordion.appendChild(titleItem);
                    accordion.appendChild(textItem);
                });

                // About tracks & licenses

                faq = result.page_faq_tl;
                accordion = document.querySelector("#faqAccordionTL");
                accordion.textContent = "";

                faq.map((item, index) => {
                    const faqItem = document.querySelector(`${modelId} .faq-item`).cloneNode(true);
                    const titleItem = faqItem.querySelector(".faqTit");
                    const title = titleItem.querySelector("span");
                    titleItem.dataset.target = "#f_tl_" + index;
                    title.textContent = item.title;
                    const textItem = faqItem.querySelector(".faqText");
                    const text = textItem.querySelector("span");
                    textItem.setAttribute("data-parent", "#faqAccordionTL");
                    textItem.id = "f_tl_" + index;
                    text.innerHTML = item.content;
                    accordion.appendChild(titleItem);
                    accordion.appendChild(textItem);
                });
            })
            .catch((error) => {
                Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                jQuery(".js-critical-error").show();
            });
    }

    renderFaqArtistData() {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("DataManager - Fetching Faq Artist Data");
        setTimeout(() => {
            jQuery("#faqAccordion .js-preloader").show();
        }, 200);
        fetch(Globals.WS_URL +"?mode=PAGE.FAQ.ARTIST")
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("DataManager - Fetch Faq Artist Data OK");
                const faq = result.page_faq;
                const accordion = document.querySelector("#faqAccordion");
                accordion.textContent = "";
                const modelId = "#model-faq-item";

                faq.map((item, index) => {
                    const faqItem = document.querySelector(`${modelId} .faq-item`).cloneNode(true);
                    const titleItem = faqItem.querySelector(".faqTit");
                    const title = titleItem.querySelector("span");
                    titleItem.dataset.target = "#f" + index;
                    title.textContent = item.title;
                    const textItem = faqItem.querySelector(".faqText");
                    const text = textItem.querySelector("span");
                    textItem.id = "f" + index;
                    text.innerHTML = item.content;
                    accordion.appendChild(titleItem);
                    accordion.appendChild(textItem);
                });
            })
            .catch((error) => {
                Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                jQuery(".js-critical-error").show();
            });
    }

    renderSubscriptionData() {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("DataManager - Fetching Subscription Data");

        const token = this.getCookie("user_token");

        let code = "";

        const urlParams = new URLSearchParams(window.location.search);
        const paramPromoCode = urlParams.get("promoCode");
        if (paramPromoCode) {
            code = "&promo_code=" + paramPromoCode;
        }

        const inputCode = document.querySelector(".promo-code-form input");
        if (inputCode?.value) {
            code = "&promo_code=" + inputCode.value;
        }

        const ref = {
            "2.M": "2m",
            "2.Y": "2y",
            "4.M": "4m",
            "4.Y": "4y",
            // "5.Y": "5y",
        };

        const url = `${Globals.WS_URL}?mode=PRICING&token=${token}${code}`;
        fetch(url)
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("DataManager - Fetch Subscription Data OK");
                if (result.SingleLicence) {
                    const singleLicense = result.SingleLicence;
                    const card = document.querySelector(".cards-group.standard .card-body.single-license");
                    if (card) {
                        const price = card.querySelector(".price");
                        const showPrice = this.formatPrice(singleLicense.price).toString().split(".");
                        if (price) {
                            price.querySelector(".integer").textContent = showPrice[0];
                            price.querySelector(".cent").textContent = showPrice[1] ? `.${showPrice[1]}` : "";
                        }
                    }
                }
                if (result.pricing) {
                    const pricing = result.pricing;
                    pricing.map((item) => {
                        // ---
                        const cards = document.querySelectorAll(`.cards-group.commercial .card-body.card-cc-${ref[item.cc]}`);
                        Array.from(cards).map((card) => {
                            if (card) {
                                // ---
                                const price = card.querySelector(".price");
                                const showPrice = this.formatPrice(item.price / 12).toString().split(".");
                                if (price) {
                                    // console.log("Pricing: " + ref[item.cc] + " " + item.price);
                                    price.querySelector(".integer").textContent = showPrice[0];
                                    price.querySelector(".cent").textContent = showPrice[1] ? `.${showPrice[1]}` : "";
                                }
                                // ---
                                const button = card.parentNode.querySelector(".payment-send");
                                if (token && button && code) {
                                    // href from Profile.js / buySubscription
                                    button.href += code;
                                }
                                // ---
                                const switchTime = card.querySelector(".switch-time");
                                if (switchTime) {
                                    const yearPrice = card.querySelector(".year-price");
                                    if (yearPrice) {
                                        yearPrice.textContent = this.formatPrice(item.price).toString().split(".");
                                    }
                                }
                            }
                        });
                        // ---
                        const prices = document.querySelectorAll(`.cards-group.commercial .card-body .price-${ref[item.cc]}`);
                        Array.from(prices).map((price) => {
                            // ---
                            console.log(">> " + ref[item.cc] + " " + item.price);
                            const showPrice = this.formatPrice(item.price / ((item.cc.indexOf(".Y")==1)? 12 : 1)  ).toString().split(".");
                            if (price) {
                                price.querySelector(".integer").textContent = showPrice[0];
                                price.querySelector(".cent").textContent = showPrice[1] ? `.${showPrice[1]}` : "";
                            }
                            // ---
                            const button = document.querySelectorAll(`.cards-group.commercial .card-body .payment-send-${ref[item.cc]}`);
                            if (token && button && code) {
                                button.href += code;
                            }
                            // ---
                        });
                        // --- pricing.map END
                    });
                    // --- 
                    const switchTimesA = document.querySelectorAll(".cards-group.commercial .card-body .switch-time");
                    Array.from(switchTimesA).map((switchTime) => {
                        switchTime.onclick = null;
                        switchTime.addEventListener('click', function (event) {
                            const appleSwitch = switchTime.querySelector(".apple-switch");
                            const isOn = appleSwitch.classList.toggle("isOn");
                            Array.from(switchTime.parentNode.parentNode.querySelectorAll(".card-ccm")).map((o) => { o.style.display = (isOn) ? "none" : "inline-block"; });
                            Array.from(switchTime.parentNode.parentNode.querySelectorAll(".card-ccy")).map((o) => { o.style.display = (isOn) ? "inline-block" : "none"; });
                        }, false);
                    });
                    // ---
                }
            })
            .catch((error) => {
                Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                jQuery(".js-critical-error").show();
            });
    }

    activateInputPromoCode() {
        const _this = this;
        document.querySelector(".promo-code-form input").value = "";
        document.querySelector(".promo-code-form button").addEventListener("click", () => {
            _this.renderSubscriptionData();
        });
    }
}
